// extracted by mini-css-extract-plugin
module.exports = {"player_icon":"da51a739f7--player_icon--rrOgb"};